import { LOCALE_ID, Provider } from '@angular/core';
import { getSupportedLocale, registerSupportedLocaleData } from './supported-locales';

export function provideLocale(): Provider {
  const locale = getSupportedLocale();
  registerSupportedLocaleData(locale);

  return { provide: LOCALE_ID, useValue: locale };
}
